module.exports = __webpack_public_path__ + "static/img/21.00fd91b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/21.png
// module id = 78Zy
// module chunks = 0